<script setup lang="ts">
import { CellClickedEvent } from 'ag-grid-enterprise';
import { computed, shallowRef } from 'vue';
import { storeToRefs } from 'pinia';
import * as cols from '@/modules/common/components/ag-table/columns/marketplace-top-of-book';
import { AgTableClient } from '@/modules/common/components/ag-table';
import { VenueTopOfBookItem, VenueTopOfBookResponse } from '@/modules/marketplace/models';
import { useRateTypeStore } from '@/store/rate-type-store';

defineProps<{ items: VenueTopOfBookResponse['data'] }>();

const emit = defineEmits<{
  (e: 'click:row', cusip: string): void;
}>();

const { marketplaceRateType } = storeToRefs(useRateTypeStore());

const sortBy = shallowRef<{ colId: string; sort: 'asc' | 'desc' }>({
  colId: 'securityTicker',
  sort: 'asc',
});

const columnDefs = computed(() => {
  const config = { rateType: marketplaceRateType.value };
  return [
    cols.ticker(),
    cols.cusip(),

    cols.borrowEligibleTotalQuantity(),
    cols.borrowCounterparty(),
    cols.borrowQuantity(),
    cols.borrowRate(config),

    cols.lendRate(config),
    cols.lendQuantity(),
    cols.lendCounterparty(),
    cols.lendEligibleTotalQuantity(),
  ];
});

function getRowId(item: VenueTopOfBookItem): string {
  return item.security.cusip;
}

// @TODO: make a proper link so users can open in a new tab, for example
function handleRowClick({ data: item }: CellClickedEvent<VenueTopOfBookItem>): void {
  if (item === undefined) return;
  emit('click:row', getRowId(item));
}
</script>

<template>
  <AgTableClient
    :column-defs="columnDefs"
    data-test="top-of-book-table"
    fit-full-width
    :get-row-id="getRowId"
    :page-size="1000"
    :row-data="items"
    :sort="sortBy"
    @click:cell="handleRowClick"
  />
</template>

<style lang="scss" scoped>
::v-deep {
  .ag-cell {
    cursor: pointer;
  }

  .highlighted-border-right {
    border-right: 1px solid #ccc !important; /* @TODO: fix */
  }
}
</style>
